import { render, staticRenderFns } from "./RegisteredUserTab.vue?vue&type=template&id=65a3b7e6&scoped=true"
import script from "./RegisteredUserTab.vue?vue&type=script&lang=js"
export * from "./RegisteredUserTab.vue?vue&type=script&lang=js"
import style0 from "./RegisteredUserTab.vue?vue&type=style&index=0&id=65a3b7e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a3b7e6",
  null
  
)

export default component.exports